import React, { useState, useEffect, useRef } from 'react';
import Sidebar from './Sidebar';
import { useNavigate } from 'react-router-dom';
import { FaUserCircle } from 'react-icons/fa';
import './MainLayout.css';

const MainLayout = ({ children }) => {
  const navigate = useNavigate();
  const fullName = localStorage.getItem('full_name') || 'User';
  const email = localStorage.getItem('email') || 'user@example.com';
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setDropdownVisible(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = () => {
    setDropdownVisible((prev) => !prev);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  return (
    /* Outer shell: full viewport height, no overflow */
    <div style={styles.shell}>
      <Sidebar />

      {/* Right column: topbar + scrollable content */}
      <div style={styles.rightCol}>

        {/* Topbar — fixed height, never scrolls */}
        <div style={styles.topbar}>
          <div
            className="profile-dropdown"
            onClick={toggleDropdown}
            ref={dropdownRef}
          >
            <div className="profile-trigger">
              <FaUserCircle size={28} />
              <span style={styles.name}>{fullName}</span>
            </div>
            {dropdownVisible && (
              <div className="dropdown-content">
                <div style={styles.email}>{email}</div>
                <hr />
                <button onClick={() => navigate('/edit-account')} className="dropdown-item">Edit Account</button>
                <button onClick={() => navigate('/change-password')} className="dropdown-item">Change Password</button>
                <button onClick={handleLogout} className="dropdown-item">Logout</button>
              </div>
            )}
          </div>
        </div>

        {/* Scrollable page content — THIS is the only scroll container */}
        <div style={styles.pageContent}>
          {children}
        </div>

      </div>
    </div>
  );
};

const styles = {
  /* Full-viewport flex row — must NOT scroll */
  shell: {
    display:  'flex',
    height:   '100vh',
    overflow: 'hidden',
    width:    '100%',
  },

  /* Right column: fills remaining width, flex column for topbar + content */
  rightCol: {
    marginLeft:     '220px',      /* matches your Sidebar width */
    width:          'calc(100% - 220px)',
    display:        'flex',
    flexDirection:  'column',
    height:         '100vh',
    overflow:       'hidden',     /* children handle their own scroll */
  },

  /* Topbar: fixed height, never scrolls */
  topbar: {
    flexShrink:   0,              /* never shrinks */
    display:      'flex',
    justifyContent: 'flex-end',
    alignItems:   'center',
    height:       '60px',
    background:   '#f8f9fa',
    padding:      '0 20px',
    boxShadow:    '0 1px 4px rgba(0,0,0,0.1)',
    position:     'relative',
    zIndex:       50,
  },

  /* Page content: takes remaining height and SCROLLS */
  pageContent: {
    flex:       1,                /* fill all height below topbar */
    overflowY:  'auto',          /* ← THE SCROLL FIX */
    overflowX:  'hidden',
    minHeight:  0,               /* required for flex children to shrink */
    padding:    '20px',
  },

  name: {
    marginLeft: '8px',
    fontWeight: 600,
    fontSize:   '14px',
  },
  email: {
    fontSize:    '14px',
    marginBottom: '10px',
    color:       '#555',
  },
};

export default MainLayout;